<script>
  import { onDestroy } from 'svelte';
  import { fade } from 'svelte/transition';
  import { listenToChannel, listenToChat, listenToChatPreview } from '../../../Api/api';

  export let id = '';

  let unsubscribeListenToPublished;
  let unsubscribeListenToPreview;
  let unsubscribeListenToChannel;

  let numberOfAdminMessages = 0;
  let numberOfAdminAnswers = 0;
  let totalNumberOfMessages = 0;
  let totalNumberOfPublishedUserMessages = 0;
  let totalNumberOfUserMessagesIn = 0;
  let numberOfDeletedMessages = 0;
  let totalPublishedUsers = 0;

  let channel;

  $: id && listenToPreviewChatData(id);
  $: id && listenToPublishedChatData(id);
  $: id && listenToChannelData(id);

  onDestroy(async () => {
    if (unsubscribeListenToPublished) {
      unsubscribeListenToPublished();
    }
    if (unsubscribeListenToPreview) {
      unsubscribeListenToPreview();
    }
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
    }
  });

  const listenToChannelData = async (channelId) => {
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
      unsubscribeListenToChannel = null;
    }
    unsubscribeListenToChannel = await listenToChannel(channelId, (docRef) => {
      if (docRef.exists) {
        channel = { ...docRef.data(), id: docRef.id };
      }
    });
  };

  const listenToPreviewChatData = async (channelId) => {
    if (unsubscribeListenToPreview) {
      unsubscribeListenToPreview();
      unsubscribeListenToPreview = null;
    }
    unsubscribeListenToPreview = await listenToChatPreview(channelId, (snapShot) => {
      const chatData = [];
      snapShot.forEach((doc) => {
        chatData.push({ ...doc.data(), commentId: doc.id });
      });

      const deleted = chatData.filter((c) => c.d);
      numberOfDeletedMessages = deleted.length;
      const total = chatData.filter((c) => !c.m);
      totalNumberOfUserMessagesIn = total.length;
    });
  };

  const listenToPublishedChatData = async (channelId) => {
    if (unsubscribeListenToPublished) {
      unsubscribeListenToPublished();
      unsubscribeListenToPublished = null;
    }
    unsubscribeListenToPublished = await listenToChat(channelId, (snapShot) => {
      const chatData = [];

      snapShot.forEach((doc) => {
        chatData.push({ ...doc.data(), id: doc.id });
      });

      const adminMessages = chatData.filter((c) => c.m);
      const userMessages = chatData.filter((c) => !c.m);
      const answers = chatData.filter((c) => c.originalAuthor);

      const u = chatData
        .filter((d) => !d.m)
        .reduce((acc, cur) => {
          let c = acc[cur.userId] ? acc[cur.userId] : [];
          c.push(cur);
          acc[cur.userId] = c;
          return acc;
        }, {});

      totalPublishedUsers = Object.keys(u).length;
      totalNumberOfMessages = chatData.length;
      numberOfAdminMessages = adminMessages.length;
      numberOfAdminAnswers = answers.length;
      totalNumberOfPublishedUserMessages = userMessages.length;
    });
  };
</script>

<div class="stats-container" in:fade>
  <p class="label">Totalt antall publiserte meldinger (admin og brukere)</p>
  <p class="value">{totalNumberOfMessages}</p>
  <p class="label">Antall admin-meldinger</p>
  <p class="value">
    {`${numberOfAdminMessages} hvorav ${numberOfAdminAnswers} er svar på meldinger`}
  </p>
  <p class="label">Antall publiserte brukermeldinger</p>
  <p class="value">{totalNumberOfPublishedUserMessages}</p>
  <p class="label">Totalt antall brukermeldinger</p>
  <p class="value">{totalNumberOfUserMessagesIn}</p>
  <p class="label">Slettete meldinger</p>
  <p class="value">{numberOfDeletedMessages}</p>
  <p class="label">Antall brukere (ikke inkludert admin'er)</p>
  <p class="value">{totalPublishedUsers}</p>
</div>

<style src="./stats.scss">
</style>
